(function () {
  'use strict';

  if (window.PesadoCompatibilityDataLoaderVersion === '20260813') return;
  window.PesadoCompatibilityDataLoaderVersion = '20260813';

  const compatibilityDataScript = document.currentScript;
  const compatibilityThemeAssetBase = compatibilityDataScript && compatibilityDataScript.src
    ? compatibilityDataScript.src.replace(/[^/?#]+(?:\?[^#]*)?$/, '')
    : '';

  function hydrateManagerConfiguration() {
    if (window.PesadoCompatibilityManagerConfig) return;
    const source = document.getElementById('pesado-compatibility-manager-config');
    if (!source) return;
    try {
      const encoded = (source.textContent || '').replace(/\s/g, '');
      const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
      const lookup = {};
      for (let alphabetIndex = 0; alphabetIndex < alphabet.length; alphabetIndex += 1) {
        lookup[alphabet.charAt(alphabetIndex)] = alphabetIndex;
      }
      const bytes = [];
      let buffer = 0;
      let bitCount = 0;
      for (let encodedIndex = 0; encodedIndex < encoded.length; encodedIndex += 1) {
        const character = encoded.charAt(encodedIndex);
        if (character === '=') break;
        const value = lookup[character];
        if (typeof value !== 'number') continue;
        buffer = (buffer << 6) | value;
        bitCount += 6;
        if (bitCount >= 8) {
          bitCount -= 8;
          bytes.push((buffer >> bitCount) & 255);
          buffer &= (1 << bitCount) - 1;
        }
      }
      const characters = [];
      for (let byteIndex = 0; byteIndex < bytes.length;) {
        const first = bytes[byteIndex];
        let codePoint;
        if (first < 128) {
          codePoint = first;
          byteIndex += 1;
        } else if ((first & 224) === 192) {
          codePoint = ((first & 31) << 6) | (bytes[byteIndex + 1] & 63);
          byteIndex += 2;
        } else if ((first & 240) === 224) {
          codePoint = ((first & 15) << 12) | ((bytes[byteIndex + 1] & 63) << 6) | (bytes[byteIndex + 2] & 63);
          byteIndex += 3;
        } else {
          codePoint = ((first & 7) << 18) | ((bytes[byteIndex + 1] & 63) << 12) | ((bytes[byteIndex + 2] & 63) << 6) | (bytes[byteIndex + 3] & 63);
          byteIndex += 4;
        }
        if (codePoint <= 65535) {
          characters.push(String.fromCharCode(codePoint));
        } else {
          codePoint -= 65536;
          characters.push(String.fromCharCode(55296 + (codePoint >> 10)));
          characters.push(String.fromCharCode(56320 + (codePoint & 1023)));
        }
      }
      window.PesadoCompatibilityManagerConfig = JSON.parse(characters.join(''));
    } catch (error) {
      console.error('[Pesado Compatibility] Invalid Manager publication.', error);
    }
  }

  hydrateManagerConfiguration();

  // Central installation-video directory. Replace a YouTube ID here to update
  // every Compatibility Guide and product-page surface that uses that video.
  const installationVideos = {
    portafilter: 'rjotSdmBPlA',
    tamper: '3pE-PHIJR7Y',
    basket: 'j3s8j8KWZb4',
    distributor: '4AB9uFxBEIc',
    showerScreen: {
      gaggia: '4ff1Bk4IxxQ',
      e61: '1ALvHagjFW8',
      mv: 'DvYe76Taihc',
      lm: '6I53wb8quxQ',
      hx: '',
      breville54: 'baKtbCFyyQE',
      brevilleEx54: 'sGofQ5ilipg',
      breville58: 'b2z4YHHRR34'
    }
  };

  const product = (id, cat, name, spec, handle, tokens, extra) => Object.assign({
    id,
    cat,
    name,
    spec,
    handle,
    tokens: tokens || []
  }, extra || {});

  const products = {
    pf_lm_e61: product('pf_lm_e61', 'portafilter', 'LM / E61 Hybrid Portafilter', '58mm · LM / E61 mount', 'hybrid-lm-e61-ns-portafilter', ['La Marzocco 6mm'], { video: true, videoId: installationVideos.portafilter, preferredVariantMatch: 'Black | Black' }),
    pf_e61_5mm: product('pf_e61_5mm', 'portafilter', 'E61 5mm Hybrid Portafilter', '58mm · E61 5mm mount', 'hybrid-lm-e61-ns-portafilter', ['E61 5mm'], { video: true, videoId: installationVideos.portafilter, preferredVariantMatch: 'Black | Black' }),
    pf_ns: product('pf_ns', 'portafilter', 'NS Hybrid Portafilter', '58mm · Nuova Simonelli mount', 'hybrid-lm-e61-ns-portafilter', ['Nuova Simonelli'], { video: true, videoId: installationVideos.portafilter, preferredVariantMatch: 'Black | Black' }),
    pf_breville_58: product('pf_breville_58', 'portafilter', 'Breville 58mm Hybrid Portafilter', '58mm · Dual Boiler / Oracle', 'hybrid-breville-54-58-portafilter', ['Breville 58'], { video: true, videoId: installationVideos.portafilter, preferredVariantMatch: 'Black | Black' }),
    pf_breville_54: product('pf_breville_54', 'portafilter', 'Breville 54mm Hybrid Portafilter', '54mm · Bambino / Barista', 'hybrid-breville-54-58-portafilter', ['Breville 54'], { video: true, videoId: installationVideos.portafilter, preferredVariantMatch: 'Black | Black' }),
    pf_lm_6mm: product('pf_lm_6mm', 'portafilter', 'LM 6mm Hybrid Portafilter', '58mm · La Marzocco 6mm', 'hybrid-lm-e61-ns-portafilter', ['La Marzocco 6mm'], { video: true, videoId: installationVideos.portafilter, preferredVariantMatch: 'Black | Black' }),
    pf_gaggia: product('pf_gaggia', 'portafilter', 'Gaggia Hybrid Portafilter', '58mm · Gaggia mount', 'hybrid-lm-e61-ns-portafilter', ['Gaggia'], { video: true, videoId: installationVideos.portafilter, preferredVariantMatch: 'Black | Black' }),
    t_585: product('t_585', 'tamper', 'Pesado Tamper 58.5mm', 'Flat · 58.5mm', 'pesado-coffee-tamper-58mm-54mm', ['58.5mm'], { video: true, videoId: installationVideos.tamper, preferredVariantMatch: 'Black / Silver' }),
    t_535: product('t_535', 'tamper', 'Pesado Tamper 53.5mm', 'Flat · 53.5mm', 'pesado-coffee-tamper-58mm-54mm', ['53.5mm'], { video: true, videoId: installationVideos.tamper, preferredVariantMatch: 'Black / Silver' }),
    dc_58: product('dc_58', 'dosing', 'Dosing Cup 58mm', 'Stainless · 58mm', 'dosing-cup', ['58mm Dosing Cup']),
    dc_54: product('dc_54', 'dosing', 'Dosing Cup 54mm', 'Stainless · 54mm', 'dosing-cup', ['54mm Dosing Cup']),
    ring_58: product('ring_58', 'ring', 'Dosing Ring 58mm', 'Magnetic · 58mm', 'dosing-ring', ['58mm']),
    ring_54: product('ring_54', 'ring', 'Dosing Ring 54mm', 'Magnetic · 54mm', 'dosing-ring', ['54mm']),
    puck_58: product('puck_58', 'puck', 'Puck Diffuser Screen 58.5mm', '100μm · 58.5mm', '58mm-puck-diffuser-screen', ['58.5mm']),
    puck_54: product('puck_54', 'puck', 'Puck Diffuser Screen 53.5mm', '100μm · 53.5mm', '58mm-puck-diffuser-screen', ['53.5mm']),
    basket_58: product('basket_58', 'basket', 'HE Basket 58mm', 'High extraction · 58mm', 'high-extraction-filter-basket', [], { video: true, videoId: installationVideos.basket }),
    basket_54: product('basket_54', 'basket', 'HE Basket 54mm', 'High extraction · Breville 54mm', 'pesado-he-breville-54mm-high-extraction-basket', [], { video: true, videoId: installationVideos.basket }),
    ep_58: product('ep_58', 'basket', 'EP Basket 58mm · 18g', 'Electro polished · 58mm', 'pesado-ep-filter-basket', ['EP-18g'], { video: true, videoId: installationVideos.basket }),
    ep_54: product('ep_54', 'basket', 'EP Basket Breville 54mm · 18g', 'Electro polished · Breville 54mm', 'ep-electro-polised-filter-basket-54mm', ['EP-Breville54mm-18g'], { video: true, videoId: installationVideos.basket }),
    gd_585: product('gd_585', 'distrib', 'Impact Gravity Distributor 58mm', 'Impact · 58.4mm', 'impact-gravity-distributor', ['58mm'], { video: true, videoId: installationVideos.distributor }),
    gd_535: product('gd_535', 'distrib', 'Impact Gravity Distributor 54mm', 'Impact · 53.5mm', 'impact-gravity-distributor', ['54mm'], { video: true, videoId: installationVideos.distributor }),
    clump_metallic: product('clump_metallic', 'clump', 'Stainless Steel Clump Crusher V2.0', 'WDT · Metallic finish', 'clump-crusher-wdt-tool', []),
    clump_wooden: product('clump_wooden', 'clump', 'Wooden Clump Crusher', 'WDT · Wooden finishes', 'pesado-wdt-clump-crusher-wooden', []),
    stand_wdt: product('stand_wdt', 'stand', 'Stand for WDT Clump Crusher 2.0', 'Universal WDT tool stand', 'stand-for-wdt-clump-crusher-2-0', []),
    hd_e61: product('hd_e61', 'screen', 'HD Shower Screen — E61', 'High diffusion · E61 group', 'pesado-hd-high-diffusion-shower-screen', ['E61'], { video: true, videoId: installationVideos.showerScreen.lm }),
    hd_mv: product('hd_mv', 'screen', 'HD Shower Screen — MV', 'High diffusion · MV group', 'pesado-hd-high-diffusion-shower-screen', ['MV'], { video: true, videoId: installationVideos.showerScreen.lm }),
    hd_lm: product('hd_lm', 'screen', 'HD Shower Screen — LM', 'High diffusion · La Marzocco', 'pesado-hd-high-diffusion-shower-screen', ['LM'], { video: true, videoId: installationVideos.showerScreen.lm }),
    hd_54: product('hd_54', 'screen', 'HD Shower Screen — Breville 54mm', 'High diffusion · Breville 54mm', 'high-diffusion-espresso-shower-screen-breville', ['BR54HD'], { video: true, videoId: installationVideos.showerScreen.breville54 }),
    hd_ex54: product('hd_ex54', 'screen', 'HD Shower Screen — Breville 54mm', 'High diffusion · Barista Express / Infuser', 'high-diffusion-espresso-shower-screen-breville', ['BR54HD'], { video: true, videoId: installationVideos.showerScreen.breville54 }),
    hd_br58: product('hd_br58', 'screen', 'HD Shower Screen — Breville 58mm', 'High diffusion · Breville 58mm', 'high-diffusion-espresso-shower-screen-breville', ['BR58HD'], { video: true, videoId: installationVideos.showerScreen.breville58 }),
    hd_hx: product('hd_hx', 'screen', 'HD Shower Screen — HX', 'High diffusion · HX group', 'pesado-hd-high-diffusion-shower-screen', ['HX'], { video: true, videoId: installationVideos.showerScreen.lm }),
    hd_ga: product('hd_ga', 'screen', 'HD Shower Screen — Gaggia', 'High diffusion · Gaggia Classic', 'high-diffusion-espresso-shower-screen-gaggia', [], { video: true, videoId: installationVideos.showerScreen.gaggia }),
    dl_51_bundle: product('dl_51_bundle', 'bundle', "DeLonghi 51mm Extraction Bundle", 'PSD-HD-DL + EP-DL-18g + 0.2mm contact mesh', 'hd-delonghi-kit', [])
  };

  const prep58 = ['ep_58', 't_585', 'gd_585', 'basket_58', 'dc_58', 'ring_58', 'puck_58'];
  const prep54 = ['ep_54', 't_535', 'gd_535', 'basket_54', 'dc_54', 'ring_54', 'puck_54'];
  const dosing58 = ['basket_58', 'dc_58', 'ring_58', 'puck_58'];
  const universalRecommendations = ['clump_metallic', 'clump_wooden', 'stand_wdt'];

  const model = (name, additions, base, metadata) => Object.assign({
    name,
    products: Array.from(new Set([].concat(additions || [], base || [])))
  }, metadata || {});
  const m58 = (name, additions, metadata) => model(name, additions, prep58, metadata);
  const m54 = (name, additions, metadata) => model(name, additions, prep54, metadata);
  const empty = (name) => model(name || '—', [], []);
  const brand = (name, country, tier, models, popular) => ({
    name,
    country,
    tier,
    models,
    popular: Boolean(popular),
    slug: name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
  });

  const brands = [
    brand('ACS', 'IT', 'pro', [m58('E61 models', ['pf_lm_e61', 'hd_e61'])]),
    brand('Ascaso', 'ES', 'home', [
      m58('Baby T', ['hd_e61']),
      model('Dream', [], dosing58),
      m58('Duo PID', ['pf_e61_5mm', 'hd_e61']),
      m58('Uno', ['pf_e61_5mm', 'hd_e61'])
    ]),
    brand('Belleza', 'AU', 'home', [
      m58('Bellona', ['pf_e61_5mm', 'hd_mv']),
      m58('E61 group', ['pf_e61_5mm', 'hd_hx'])
    ]),
    brand('Bezzera', 'IT', 'pro', [
      m58('BZ groups', ['pf_ns', 'hd_mv']),
      m58('Commercial', ['pf_ns']),
      m58('E61 models', ['pf_e61_5mm', 'hd_e61']),
      m58('Lever models', ['pf_e61_5mm'])
    ]),
    brand('Brasilia', 'IT', 'pro', [m58('E61 models', ['pf_lm_e61'])]),
    brand('Breville', 'AU', 'home', [
      m54('The Bambino', ['pf_breville_54', 'hd_54']),
      m54('The Bambino Plus', ['pf_breville_54', 'hd_54']),
      m54('Barista Express / Sage', ['pf_breville_54', 'hd_ex54']),
      m54('Barista Express Impress', ['pf_breville_54', 'hd_54']),
      m54('The Barista Pro', ['pf_breville_54', 'hd_54']),
      m54('The Barista Touch', ['pf_breville_54', 'hd_54']),
      m54('The Barista Touch Impress', ['pf_breville_54', 'hd_54']),
      m54('The Infuser', ['pf_breville_54', 'hd_ex54']),
      m54('Duo-Temp Pro', ['pf_breville_54', 'hd_54']),
      m58('The Dual Boiler', ['pf_breville_58', 'hd_br58']),
      m58('Dynamic Duo', ['pf_breville_58', 'hd_br58']),
      m58('The Oracle', ['pf_breville_58', 'hd_br58']),
      m58('The Oracle Touch', ['pf_breville_58', 'hd_br58']),
      m58('The Oracle Dual Boiler', ['pf_breville_58', 'hd_br58']),
      m58('The Oracle Jet', ['pf_breville_58'], {
        screenCompatibility: false,
        compatibilityNotice: 'A compatible High Diffusion shower screen is not available for the Oracle Jet yet. The tools shown below are compatible with this model.'
      })
    ], true),
    brand('Brugnetti', 'IT', 'pro', [
      m58('Aurora', ['pf_lm_e61']),
      m58('E61 models', ['pf_lm_e61', 'hd_e61'])
    ]),
    brand('Dalla Corte', 'IT', 'pro', [empty()]),
    brand("De'Longhi", 'IT', 'home', [
      model('La Specialista Maestro Manual', ['dl_51_bundle']),
      model('La Specialista Touch Manual', ['dl_51_bundle']),
      model('La Specialista Opera Manual', ['dl_51_bundle']),
      model('La Specialista Arte Evo Cold Brew', ['dl_51_bundle']),
      model('La Specialista Arte Manual Coffee', ['dl_51_bundle'])
    ], true),
    brand('ECM', 'DE', 'pro', [
      m58('Casa V', ['pf_lm_e61', 'hd_mv']),
      m58('E61 models', ['pf_lm_e61', 'hd_e61']),
      m58('Puristika', ['pf_lm_e61', 'hd_e61'])
    ]),
    brand('Elektra', 'IT', 'pro', [
      m58('KUP', ['pf_lm_e61', 'hd_mv']),
      empty('Lever models'),
      m58('Verve', ['pf_lm_e61', 'hd_mv'])
    ]),
    brand('Expobar', 'ES', 'pro', [
      m58('Commercial', ['pf_lm_e61', 'hd_hx']),
      m58('Office', ['pf_lm_e61', 'hd_hx'])
    ]),
    brand('CREM', 'ES', 'pro', [m58('Commercial', ['pf_lm_e61', 'hd_hx'])]),
    brand('Flair', 'IN', 'home', [m58('58 LE', ['pf_lm_e61']), m58('58X', ['pf_lm_e61'])]),
    brand('Fracino', 'GB', 'pro', [m58('E61 models', ['pf_lm_e61'])]),
    brand('Francis Francis', 'IT', 'home', [empty()]),
    brand('Gaggia', 'IT', 'home', [
      m58('Classic', ['pf_gaggia', 'hd_ga']),
      m58('Classic Pro', ['pf_gaggia', 'hd_ga']),
      m58('Classic Evo', ['pf_gaggia', 'hd_ga']),
      m58('Classic E24', ['pf_gaggia', 'hd_ga']),
      m58('Classic Pro E24', ['pf_gaggia', 'hd_ga'])
    ], true),
    brand('Isomac', 'IT', 'pro', [m58('E61 models', ['pf_lm_e61', 'hd_e61'])]),
    brand('IZZO — Alex', 'IT', 'pro', [m58('E61 models', ['pf_lm_e61', 'hd_e61'])]),
    brand('La Marzocco', 'IT', 'pro', [
      m58('GS3 AV / MP', ['pf_lm_6mm', 'hd_lm']),
      m58('KB90', []),
      m58('Leva X', []),
      m58('Linea', ['pf_lm_6mm', 'hd_lm']),
      m58('Micra', ['pf_lm_6mm', 'hd_lm']),
      m58('Mini', ['pf_lm_6mm', 'hd_lm'])
    ], true),
    brand('La Pavoni', 'IT', 'home', [m58('E61 models', ['pf_lm_e61', 'hd_e61'])]),
    brand('La Spaziale', 'IT', 'pro', [empty()]),
    brand('Lelit', 'IT', 'home', [
      m58('Mara X', ['pf_e61_5mm', 'hd_e61']),
      m58('Bianca', ['pf_e61_5mm', 'hd_e61']),
      m58('Elizabeth', ['pf_e61_5mm', 'hd_mv']),
      m58('Victoria', ['pf_e61_5mm', 'hd_mv'])
    ], true),
    brand('LUCCA', 'US', 'home', [m58('x58', ['pf_lm_e61', 'hd_e61'])]),
    brand('Newton', 'IT', 'pro', [m58('Brua3', ['pf_lm_e61'])]),
    brand('Nuova Simonelli', 'IT', 'pro', [
      m58('MOOD', ['pf_ns', 'hd_mv']),
      m58('Musica', ['pf_ns', 'hd_mv']),
      m58('Oscar', ['pf_ns', 'hd_mv']),
      m58('Commercial', ['pf_ns', 'hd_mv'])
    ], true),
    brand('Nurri', 'IT', 'pro', [m58('58mm model', ['pf_lm_e61'])]),
    brand('Orchestrale', 'IT', 'pro', [
      m58('Etnica', ['pf_lm_e61', 'hd_e61']),
      m58('NOTA', ['pf_lm_e61', 'hd_e61']),
      m58('Phonica', ['pf_lm_e61', 'hd_e61']),
      m58('Radiofonica', ['pf_lm_e61', 'hd_e61'])
    ]),
    brand('Profitec', 'DE', 'pro', [
      m58('E61 models', ['pf_lm_e61', 'hd_e61']),
      m58('Go', ['pf_e61_5mm', 'hd_mv']),
      m58('Move', ['pf_e61_5mm', 'hd_mv']),
      m58('Pro Series E61 Group', ['pf_lm_e61', 'hd_e61']),
      m58('Leva Pro Series', ['pf_lm_e61'])
    ], true),
    brand('Promac', 'IT', 'pro', [m58('Commercial', ['pf_lm_e61'])]),
    brand('Quick Mill', 'IT', 'home', [
      m58('E61 models', ['pf_lm_e61', 'hd_e61']),
      m58('Rapida', ['pf_lm_e61']),
      m58('Pop Up', ['pf_e61_5mm', 'hd_mv'])
    ]),
    brand('Rancilio', 'IT', 'pro', [
      m58('Commercial', ['pf_lm_e61']),
      m58('Silvia Pro X', ['pf_e61_5mm', 'hd_mv']),
      m58('Silvia V6 and under', ['pf_e61_5mm', 'hd_mv'])
    ], true),
    brand('Rocket', 'IT', 'home', [
      m58('Domestic — all E61 models', ['pf_lm_e61', 'hd_e61']),
      m58('R9 (R NINE ONE)', ['pf_lm_e61'])
    ], true),
    brand('Sage', 'GB', 'home', [m54('54mm', ['pf_breville_54', 'hd_54']), m58('58mm', ['pf_breville_58', 'hd_br58'])]),
    brand('San Remo', 'IT', 'pro', [m58('Cube R', ['pf_e61_5mm']), m58('YOU', ['pf_e61_5mm'])]),
    brand('Slayer', 'US', 'pro', [m58('Commercial', ['pf_e61_5mm', 'hd_lm'])]),
    brand('Synesso', 'US', 'pro', [m58('Commercial', ['pf_e61_5mm', 'hd_lm'])]),
    brand('Solis', 'CH', 'home', [m54('54mm', ['pf_breville_54', 'hd_54']), m58('58mm', ['pf_breville_58', 'hd_br58'])]),
    brand('Stone', 'CA', 'pro', [m58('All models', ['pf_lm_e61', 'hd_e61'])]),
    brand('VBM (Vibiemme)', 'IT', 'pro', [m58('E61 models', ['pf_lm_e61', 'hd_e61'])]),
    brand('Victoria Arduino', 'IT', 'pro', [
      m58('Commercial', ['pf_ns', 'hd_mv']),
      m58('Eagle One Prima', ['pf_ns', 'hd_mv'])
    ], true),
    brand('Wega', 'IT', 'pro', [m58('Astoria group', ['pf_ns', 'hd_mv']), m58('E61 group', ['pf_lm_e61', 'hd_e61'])]),
    brand('Kees Van Der Westen', 'NL', 'pro', [m58('Commercial', ['pf_e61_5mm'])]),
    brand('MAVAM', 'US', 'pro', [m58('MACH / Undercounter', ['pf_e61_5mm', 'hd_mv'])]),
    brand('Turin', 'CN', 'pro', [m58('E61 group', ['pf_lm_e61', 'hd_hx'])])
  ];

  brands.forEach((item) => {
    const ids = new Set();
    item.models.forEach((entry) => entry.products.forEach((id) => ids.add(id)));
    item.productCount = ids.size;
  });

  const categoryLabels = {
    bundle: 'Extraction Bundle',
    screen: 'HD Shower Screen',
    portafilter: 'Portafilter',
    tamper: 'Tamper',
    distrib: 'Gravity Distributor',
    basket: 'HE Basket',
    dosing: 'Dosing Cup',
    ring: 'Dosing Ring',
    puck: 'Puck Screen',
    clump: 'Clump Crusher',
    stand: 'Tool Stand'
  };
  const categoryOrder = ['bundle', 'screen', 'portafilter', 'tamper', 'distrib', 'basket', 'dosing', 'ring', 'puck', 'clump', 'stand'];

  const variantRecommendations = {
    'pesado-hd-high-diffusion-shower-screen': [
      { match: ['E61'], products: ['pf_lm_e61', 'pf_e61_5mm', 't_585', 'gd_585', 'basket_58', 'puck_58'] },
      { match: ['LM'], products: ['pf_lm_6mm', 't_585', 'gd_585', 'basket_58', 'ring_58', 'puck_58'] },
      { match: ['HX'], products: ['t_585', 'gd_585', 'basket_58', 'dc_58', 'ring_58', 'puck_58'] },
      { match: ['MV'], products: ['t_585', 'gd_585', 'basket_58', 'dc_58', 'ring_58', 'puck_58'] }
    ],
    'high-diffusion-espresso-shower-screen-breville': [
      { match: ['BR54HD'], products: ['pf_breville_54', 't_535', 'gd_535', 'basket_54', 'ring_54', 'puck_54'] },
      { match: ['BR58HD'], products: ['pf_breville_58', 't_585', 'gd_585', 'basket_58', 'ring_58', 'puck_58'] }
    ],
    'high-diffusion-espresso-shower-screen-gaggia': [
      { match: [], products: ['pf_gaggia', 't_585', 'gd_585', 'basket_58', 'dc_58', 'ring_58', 'puck_58'] }
    ],
    'hd-delonghi-kit': [
      { match: [], products: [] }
    ]
  };

  const recommendationFamilies = {
    br54: {
      label: 'Breville 54mm',
      triggers: ['breville-54mm-extraction-bundle-1'],
      triggerSkus: ['PSD-HD-BR54'],
      includedByTrigger: {
        'breville-54mm-extraction-bundle-1': ['hd_54', 'ep_54']
      },
      products: ['hd_54', 't_535', 'gd_535', 'basket_54', 'ring_54', 'puck_54'],
      kit: ['hd_54', 'ep_54', 'pf_breville_54', 'clump_metallic', 'stand_wdt']
    },
    br58: {
      label: 'Breville 58mm',
      triggers: [],
      triggerSkus: ['PSD-HD-BR58'],
      products: ['hd_br58', 't_585', 'gd_585', 'basket_58', 'ring_58', 'puck_58'],
      kit: ['hd_br58', 'ep_58', 'pf_breville_58', 'clump_metallic', 'stand_wdt']
    },
    gaggia: {
      label: 'Gaggia',
      triggers: [],
      triggerSkus: ['PSD-HD-GA'],
      products: ['t_585', 'gd_585', 'basket_58', 'ring_58', 'puck_58'],
      kit: ['hd_ga', 'ep_58', 'pf_gaggia', 'clump_metallic', 'stand_wdt']
    },
    lm: {
      label: 'La Marzocco',
      triggers: [],
      triggerSkus: ['PSD-HD-LM'],
      products: ['t_585', 'gd_585', 'basket_58', 'ring_58', 'puck_58'],
      kit: ['hd_lm', 'ep_58', 'pf_lm_6mm', 'clump_metallic', 'stand_wdt']
    },
    e61: {
      label: 'E61',
      triggers: [],
      triggerSkus: ['PSD-HD-E61'],
      products: ['t_585', 'gd_585', 'basket_58', 'ring_58', 'puck_58'],
      kit: ['hd_e61', 'ep_58', 'pf_e61_5mm', 'clump_metallic', 'stand_wdt']
    },
    hx: {
      label: 'HX',
      triggers: [],
      triggerSkus: ['PSD-HD-HX'],
      products: ['t_585', 'gd_585', 'basket_58', 'dc_58', 'ring_58', 'puck_58'],
      kit: ['hd_hx', 'ep_58', 'clump_metallic', 'stand_wdt']
    },
    mv: {
      label: 'MV',
      triggers: [],
      triggerSkus: ['PSD-HD-MV'],
      products: ['t_585', 'gd_585', 'basket_58', 'dc_58', 'ring_58', 'puck_58'],
      kit: ['hd_mv', 'ep_58', 'clump_metallic', 'stand_wdt']
    },
    delonghi: {
      label: "De'Longhi 51mm",
      triggers: ['hd-delonghi-kit'],
      triggerSkus: ['EXT_DL51_Bundle'],
      products: ['t_535', 'gd_535', 'clump_wooden'],
      kit: ['dl_51_bundle', 'clump_metallic', 'stand_wdt']
    }
  };

  function managerAssetUrl(asset) {
    if (!asset) return '';
    const candidate = asset.cdnUrl || asset.previewUrl || asset.value || '';
    if (/^https?:\/\//i.test(candidate) || /^\/\//.test(candidate)) return candidate;
    if (asset.kind !== 'theme_asset' || !compatibilityThemeAssetBase || !asset.value) return '';
    const fileName = String(asset.value).split(/[\\/]/).pop();
    return fileName ? `${compatibilityThemeAssetBase}${encodeURIComponent(fileName)}` : '';
  }

  function managerLogoDisplay(value) {
    const clamp = (candidate, minimum, maximum, fallback) => {
      const numeric = Number(candidate);
      return Number.isFinite(numeric) ? Math.min(maximum, Math.max(minimum, Math.round(numeric))) : fallback;
    };
    return {
      scale: clamp(value && value.scale, 70, 180, 100),
      offsetX: clamp(value && value.offsetX, -30, 30, 0),
      offsetY: clamp(value && value.offsetY, -30, 30, 0)
    };
  }

  function managerAssignments(configuration, modelRecord) {
    const productFamilies = configuration.productFamilies || [];
    const familyById = {};
    productFamilies.forEach((family) => { familyById[family.id] = family; });
    const assignmentSets = {};
    (configuration.assignmentSets || []).forEach((set) => { assignmentSets[set.id] = set; });
    const expandAssignment = (assignment) => Object.assign(
      {},
      assignmentSets[assignment.variantSetId] || {},
      assignment
    );
    const direct = (modelRecord.assignments || []).map(expandAssignment).sort((left, right) => left.sortOrder - right.sortOrder);
    const directProducts = new Set(direct.map((assignment) => assignment.productId));
    const seen = new Set();
    const resolved = [];

    (modelRecord.productFamilyIds || []).forEach((familyId) => {
      const family = familyById[familyId];
      if (!family || !family.enabled) return;
      (family.members || []).map(expandAssignment).sort((left, right) => left.sortOrder - right.sortOrder).forEach((member) => {
        if (directProducts.has(member.productId) || seen.has(member.productId)) return;
        seen.add(member.productId);
        resolved.push(member);
      });
    });

    direct.forEach((assignment) => {
      if (seen.has(assignment.productId)) return;
      seen.add(assignment.productId);
      resolved.push(assignment);
    });
    return resolved.filter((assignment) => assignment.enabled !== false);
  }

  function managerCompatibilityData(publication) {
    const expectedThemeId = String(window.PesadoThemeContext && window.PesadoThemeContext.themeId || '');
    if (
      !publication ||
      !publication.configuration ||
      !expectedThemeId ||
      String(publication.targetTheme && publication.targetTheme.id) !== expectedThemeId
    ) {
      return null;
    }
    const configuration = publication.configuration;
    const managerProducts = Object.assign({}, products);
    const enabledProducts = {};

    (configuration.products || []).forEach((record) => {
      if (record.recommendationEnabled === false) return;
      enabledProducts[record.id] = true;
      const variantCompatibilityImages = {};
      (record.variants || []).forEach((variant) => {
        const image = managerAssetUrl(variant.compatibilityImage);
        if (image) variantCompatibilityImages[String(variant.id)] = image;
      });
      managerProducts[record.id] = Object.assign({}, managerProducts[record.id] || {}, {
        id: record.id,
        cat: record.category,
        name: record.name,
        spec: record.spec,
        handle: record.handle,
        tokens: record.matchTokens || [],
        preferredVariantId: record.preferredVariantId || '',
        hiddenVariantIds: (record.hiddenVariantIds || []).map(String),
        compatibilityImageUrl: managerAssetUrl(record.compatibilityImage),
        variantCompatibilityImages
      });
    });

    const legacyBrands = {};
    brands.forEach((legacyBrand) => { legacyBrands[legacyBrand.slug] = legacyBrand; });
    const managerBrands = (configuration.brands || []).filter((record) => record.enabled !== false).map((record) => {
      const legacyBrand = legacyBrands[record.slug];
      const legacyModels = {};
      if (legacyBrand) {
        legacyBrand.models.forEach((legacyModel) => { legacyModels[normaliseManagerKey(legacyModel.name)] = legacyModel; });
      }
      const mappedModels = (record.models || []).filter((modelRecord) => modelRecord.enabled !== false).map((modelRecord) => {
        const assignments = managerAssignments(configuration, modelRecord).filter((assignment) => enabledProducts[assignment.productId]);
        const assignmentByProductId = {};
        assignments.forEach((assignment) => {
          assignmentByProductId[assignment.productId] = {
            role: assignment.role || 'compatible',
            defaultVariantId: String(assignment.defaultVariantId || ''),
            allowedVariantIds: (assignment.allowedVariantIds || []).map(String)
          };
        });
        return Object.assign({}, legacyModels[normaliseManagerKey(modelRecord.name)] || {}, {
          id: modelRecord.id,
          name: modelRecord.name,
          familyId: modelRecord.familyId || '',
          aliases: modelRecord.aliases || [],
          image: managerAssetUrl(modelRecord.image),
          products: assignments.map((assignment) => assignment.productId),
          managerOrdered: true,
          assignments: assignmentByProductId,
          sources: (modelRecord.sources || []).filter((source) => source.active && source.visibility === 'public'),
          compatibilityNotice: modelRecord.publicComment || ''
        });
      });
      const productIds = new Set();
      mappedModels.forEach((modelRecord) => modelRecord.products.forEach((productId) => productIds.add(productId)));
      return {
        id: record.id,
        name: record.name,
        country: record.country,
        tier: record.tier,
        models: mappedModels,
        popular: Boolean(record.popular),
        logo: managerAssetUrl(record.logo),
        logoDisplay: managerLogoDisplay(record.logoDisplay),
        slug: record.slug,
        productCount: productIds.size
      };
    });

    const managerRecommendationFamilies = {};
    (configuration.families || []).forEach((family) => {
      const legacyFamily = recommendationFamilies[family.id] || {};
      managerRecommendationFamilies[family.id] = {
        label: family.label,
        triggers: family.triggerHandles || [],
        triggerSkus: family.triggerSkus || [],
        includedByTrigger: legacyFamily.includedByTrigger || {},
        products: family.products || [],
        kit: family.kit || []
      };
    });
    const managerCategoryLabels = Object.assign({}, categoryLabels);
    const managerCategoryOrder = categoryOrder.slice();
    Object.keys(managerProducts).forEach((productId) => {
      const category = managerProducts[productId].cat;
      if (!category) return;
      if (!managerCategoryLabels[category]) managerCategoryLabels[category] = category;
      if (!managerCategoryOrder.includes(category)) managerCategoryOrder.push(category);
    });

    return {
      products: managerProducts,
      brands: managerBrands,
      categoryLabels: managerCategoryLabels,
      categoryOrder: managerCategoryOrder,
      variantRecommendations,
      recommendationFamilies: Object.keys(managerRecommendationFamilies).length ? managerRecommendationFamilies : recommendationFamilies,
      universalRecommendations: configuration.universalRecommendations || universalRecommendations,
      installationVideos,
      publication: {
        version: publication.version,
        publishedAt: publication.publishedAt,
        checksum: publication.checksum,
        targetThemeId: String(publication.targetTheme.id)
      }
    };
  }

  function normaliseManagerKey(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  const legacyCompatibilityData = {
    products,
    brands,
    categoryLabels,
    categoryOrder,
    variantRecommendations,
    recommendationFamilies,
    universalRecommendations,
    installationVideos
  };
  window.PesadoCompatibilityData = managerCompatibilityData(window.PesadoCompatibilityManagerConfig) || legacyCompatibilityData;

  let managerDataPromise = null;
  window.PesadoCompatibilityEnsureData = function () {
    if (window.PesadoCompatibilityData && window.PesadoCompatibilityData.publication) {
      return Promise.resolve(window.PesadoCompatibilityData);
    }
    if (managerDataPromise) return managerDataPromise;
    const source = document.getElementById('pesado-compatibility-manager-manifest');
    if (!source) return Promise.resolve(window.PesadoCompatibilityData);
    managerDataPromise = Promise.resolve().then(() => {
      let manifest = JSON.parse(source.textContent || '{}');
      if (typeof manifest === 'string') manifest = JSON.parse(manifest);
      const expectedThemeId = String(window.PesadoThemeContext && window.PesadoThemeContext.themeId || '');
      if (
        manifest.schemaVersion !== 3 ||
        manifest.channel !== 'live' ||
        manifest.encoding !== 'shopify-file-json' ||
        String(manifest.targetTheme && manifest.targetTheme.id) !== expectedThemeId ||
        !/^https:\/\//i.test(manifest.url || '')
      ) {
        throw new Error('The live Compatibility manifest is invalid for this theme.');
      }
      return fetch(manifest.url, { credentials: 'omit', cache: 'force-cache' })
        .then((response) => {
          if (!response.ok) throw new Error('Compatibility data returned HTTP ' + response.status + '.');
          return response.json();
        })
        .then((publication) => {
          if (
            publication.channel !== 'live' ||
            publication.checksum !== manifest.checksum ||
            Number(publication.version) !== Number(manifest.version)
          ) {
            throw new Error('The live Compatibility data does not match its manifest.');
          }
          const nextData = managerCompatibilityData(publication);
          if (!nextData) throw new Error('The live Compatibility data targets a different theme.');
          window.PesadoCompatibilityManagerConfig = publication;
          window.PesadoCompatibilityData = nextData;
          document.dispatchEvent(new CustomEvent('pesado:compatibility-data-ready', {
            detail: nextData.publication
          }));
          return nextData;
        });
    }).catch((error) => {
      console.error('[Pesado Compatibility] Live Manager data unavailable; using the built-in fallback.', error);
      return window.PesadoCompatibilityData || legacyCompatibilityData;
    });
    window.PesadoCompatibilityReady = managerDataPromise;
    return managerDataPromise;
  };
  window.PesadoCompatibilityReady = Promise.resolve(window.PesadoCompatibilityData);
})();
